export const TopupSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M10.7693 3.22751C12.3302 1.69796 14.468 0.754883 16.826 0.754883C21.6056 0.754883 25.4802 4.62951 25.4802 9.4091C25.4802 11.7672 24.5371 13.905 23.0075 15.4659M18.0623 16.827C18.0623 21.6066 14.1877 25.4812 9.40812 25.4812C4.62853 25.4812 0.753906 21.6066 0.753906 16.827C0.753906 12.0474 4.62853 8.17278 9.40812 8.17278C14.1877 8.17278 18.0623 12.0474 18.0623 16.827Z"
                stroke="#08172B"
                strokeWidth="1.5094"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.163 19.0374C12.391 19.0374 12.499 19.1454 12.499 19.3734V20.1894C12.499 20.4054 12.391 20.5254 12.163 20.5254H6.607C6.391 20.5254 6.271 20.4054 6.271 20.1894V19.3614C6.271 19.1574 6.343 19.0014 6.463 18.9414C7.123 18.6414 7.495 18.1254 7.495 17.4534C7.495 17.2614 7.471 17.0694 7.423 16.8894H6.607C6.379 16.8894 6.271 16.7694 6.271 16.5414V16.0014C6.271 15.7734 6.391 15.6534 6.607 15.6534H7.015C6.907 15.2934 6.811 14.8854 6.811 14.4174C6.811 12.9054 7.987 11.8854 9.691 11.8854C10.939 11.8854 11.851 12.4374 12.415 13.3734C12.535 13.5774 12.499 13.7334 12.307 13.8174L11.515 14.1654C11.311 14.2494 11.143 14.2494 11.035 14.1054C10.675 13.6374 10.267 13.3854 9.691 13.3854C8.911 13.3854 8.479 13.8654 8.479 14.7054C8.479 15.0294 8.527 15.3414 8.587 15.6534H10.831C11.047 15.6534 11.167 15.7854 11.167 16.0014V16.5414C11.167 16.7694 11.047 16.8894 10.831 16.8894H8.887C8.935 17.1174 8.959 17.3574 8.959 17.5854C8.959 18.1974 8.587 18.7734 8.035 19.0014V19.0374H12.163Z"
                fill="#FB5950"
            />
        </svg>
    );
};
